import React from 'react';
import { Form, FormikProps } from 'formik';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../../../../providers/root-store-provider';
import { FairPriceFormValues } from '../../form-values/fair-price-form-values-interface';
import { FairPriceTabPeParameters } from './parameters/fair-price-tab-pe-parameters';
import { FairPriceTabPeResults } from './results/fair-price-tab-pe-results';
import { FairPriceTabPeStats } from './stats/fair-price-tab-pe-stats';

interface FairPriceTabPeProps {
    formikProps: FormikProps<FairPriceFormValues>;
}

export const FairPriceTabPe: React.FC<FairPriceTabPeProps> = observer(({ formikProps }) => {
    const {
        symbolsStore: { symbolFairPriceStore, symbolDetailStore },
    } = useRootStore();
    const currency = symbolDetailStore?.general?.symbol?.currency || 'USD';
    const { eps, peRatio, fairPricePE, currentPrice, upsideDownsidePE } = symbolFairPriceStore;
    const showResult = fairPricePE > 0 && currentPrice > 0;

    return (
        <Form id={'fair-price-form'}>
            <FairPriceTabPeStats currency={currency} eps={eps} peRatio={peRatio} />
            <FairPriceTabPeParameters formikProps={formikProps} showResult={showResult} />
            <FairPriceTabPeResults
                fairPrice={fairPricePE}
                currentPrice={currentPrice}
                upsideDownside={upsideDownsidePE}
                currency={currency}
            />
        </Form>
    );
});
